import { useCallback, useSyncExternalStore } from 'react';

/** The shell breakpoint — must match the 768px media queries in
 *  layout.module.css / Sidebar.module.css / Header.module.css. */
export const MOBILE_QUERY = '(max-width: 768px)';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** True below/at the shell breakpoint (sidebar collapsed into the drawer). */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
